import React from "react";
import { Skeleton } from "primereact/skeleton";

const FoodOfferSkeleton = () => {
  return (
    <div>
      <div className="custom-skeleton">
        <Skeleton width="100%" height="250px"></Skeleton>
      </div>
      <div className="d-flex justify-content-between mx-3 mt-4">
        <Skeleton width="100%" height="165px" className="mx-1"></Skeleton>
        {/* <Skeleton width="100%" height="165px" className="mx-1"></Skeleton> */}
      </div>
      <div className="d-flex justify-content-between mx-3 my-2">
        <Skeleton width="100%" height="165px" className="mx-1"></Skeleton>
        {/* <Skeleton width="100%" height="165px" className="mx-1"></Skeleton> */}
      </div>
      <div className="d-flex justify-content-between mx-3 my-2">
        <Skeleton width="100%" height="165px" className="mx-1"></Skeleton>
        {/* <Skeleton width="100%" height="165px" className="mx-1"></Skeleton> */}
      </div>
    </div>
  );
};

export default FoodOfferSkeleton;
